import React from 'react'
import {LucideIcon} from 'lucide-react'

type Props = {
  icon: LucideIcon
  size?: number
  className?: string
  strokeWidth?: number
}

/**
 * DiibsIcon — thin wrapper around lucide-react icons.
 *
 * Usage:
 *   import {MapPin} from 'lucide-react'
 *   import {DiibsIcon} from '../common/DiibsIcon'
 *   <DiibsIcon icon={MapPin} size={20} />
 *
 * Size guide (maps to Metronic fs- classes):
 *   fs-1 → 24  fs-2 → 20  fs-3 → 18
 *   fs-4 → 17  fs-5 → 16  fs-6 → 14  fs-7 → 13
 */
const DiibsIcon: React.FC<Props> = ({icon: Icon, size = 20, className = '', strokeWidth = 2}) => {
  return <Icon size={size} className={className} strokeWidth={strokeWidth} />
}

export {DiibsIcon}
